import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Dictionary} from '../../../../shared/interface/dictionary';
import {catchError, mapTo, tap} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {of} from 'rxjs';
import {CommissionAnnex} from '../../../../shared/interface/commission-annex';
import {CommissionAnnexService} from '../../../../shared/services/commission-annex.service';
import {HttpErrorResponse} from "@angular/common/http";
import {Router} from "@angular/router";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";

export interface EditCommissionAnnexModalData {
  commissionAnnex: CommissionAnnex;
  filter: any;
  clone?: boolean;
}

@Component({
  selector: 'app-edit-annex-modal',
  templateUrl: './edit-annex-modal.component.html',
  styleUrls: ['./edit-annex-modal.component.scss']
})
export class EditAnnexModalComponent implements OnInit {

  annexObject: CommissionAnnex;
  filter: any;
  annexForm: FormGroup;
  insuranceCompanyControl: FormControl;
  internalRiskControl: FormControl;
  importerControl: FormControl;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  policyTypesControl: FormControl;
  ratePaidControl: FormControl;
  activeFromControl: FormControl;
  activeToControl: FormControl;
  activePolicyFromControl: FormControl;
  activePolicyToControl: FormControl;
  customerNameControl: FormControl;
  policyNumberControl: FormControl;
  archiveControl: FormControl;
  standard2025Control: FormControl;
  standard2026Control: FormControl;
  customCommissionControl: FormControl;
  processingRequest = false;
  selectedInsuranceCompany: InsuranceCompany;
  overvoltage = false;
  clone = false;


  constructor(
    public dialogRef: MatDialogRef<EditAnnexModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCommissionAnnexModalData,
    private fb: FormBuilder,
    private commissionAnnexService: CommissionAnnexService,
    private snack: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.annexObject = data.commissionAnnex;
    this.filter = data.filter;
    this.clone = data.clone;
    this.selectedInsuranceCompany = data.commissionAnnex.insuranceCompany;
    this.annexForm = fb.group({
      partner: this.partnerControl = fb.control('', []),
      ofwca: this.ofwcaControl = fb.control('', []),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      internalRisk: this.internalRiskControl = fb.control('', []),
      importer: this.importerControl = fb.control(''),
      policyTypes: this.policyTypesControl = fb.control([]),
      ratePaid: this.ratePaidControl = fb.control(''),
      activeFrom: this.activeFromControl = fb.control(''),
      activeTo: this.activeToControl = fb.control(''),
      customerName: this.customerNameControl = fb.control(''),
      policyNumber: this.policyNumberControl = fb.control(''),
      archive: this.archiveControl = fb.control(false),
      activePolicyFrom: this.activePolicyFromControl = fb.control(''),
      activePolicyTo: this.activePolicyToControl = fb.control(''),
      overvoltage: this.annexObject.overvoltage,
      standard2025: this.standard2025Control = fb.control(false),
      standard2026: this.standard2026Control = fb.control(false),
      customCommission: this.customCommissionControl = fb.control(false),
    });
  }

  ngOnInit(): void {
    this.overvoltage = this.annexObject.overvoltage;

    this.annexForm.setValue({
      importer: this.annexObject?.importer?.id ?? '',
      insuranceCompany: this.annexObject?.insuranceCompany?.id ?? '',
      policyTypes: this.annexObject?.policyTypes?.map((policyType: Dictionary) => policyType.id) ?? [],
      partner: this.annexObject.partner?.uuid ?? '',
      ofwca: this.annexObject.ofwca?.uuid ?? '',
      internalRisk: this.annexObject?.internalRisk?.id ?? '',
      ratePaid: this.annexObject.ratePaid,
      activeFrom: this.annexObject.activeFrom,
      activeTo: this.annexObject.activeTo,
      customerName: this.annexObject.customerName,
      policyNumber: this.annexObject.policyNumber,
      archive: this.annexObject.archive,
      activePolicyFrom: this.annexObject.activePolicyFrom,
      activePolicyTo: this.annexObject.activePolicyTo,
      overvoltage: this.annexObject.overvoltage,
      standard2025: this.annexObject.standard2025,
      standard2026: this.annexObject.standard2026,
      customCommission: this.annexObject.customCommission,
    });
  }

  save(): void {
    this.processingRequest = true;

    let textInfo;
    const partner = this.partnerControl.value;
    const ofwca = this.ofwcaControl.value;
    if (this.overvoltage){
      textInfo = 'Wybrana OFWCA posiada już aneks w tym TU. Czy chcesz dodać kolejny?';
    } else {
      textInfo = 'Wybrany Partner posiada już aneks w tym TU. Czy chcesz dodać kolejny?';
    }
    this.commissionAnnexService.findAnnex({
      partner,
      ofwca,
      insuranceCompany: this.insuranceCompanyControl.value,
      importer: this.importerControl.value,
      overvoltage: this.overvoltage
    })
      .pipe()
      .subscribe((result) => {

        if (result.items.length){

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '750px',
            data: {text: textInfo},
          });
          dialogRef.afterClosed().subscribe(resultDialogRef => {
            if (resultDialogRef) {
              // this.snack.open('Pomyślnie dodano annex', '', {duration: 2000});
              this.commissionAnnexService
                .sendForm(this.annexForm.value, this.annexObject.uuid)
                .pipe(
                  tap(() => this.processingRequest = false),
                  tap((response: Uuid) => this.dialogRef.close(response.uuid)),
                  mapTo('Pomyślnie zaktualizowano aneks'),
                  catchError(() => {
                    this.processingRequest = false;
                    return of('Podczas przesyłania formularza wystąpił błąd');
                  })
                )
                .subscribe((message: string) => {
                  this.snack.open(message, '', {
                    duration: 2000,
                  });
                });
              this.processingRequest = false;

              // this.sendForm(addNext);
            } else  {
              this.processingRequest = false;
            }
          });
        } else{
          this.processingRequest = false;

          this.commissionAnnexService
            .sendForm(this.annexForm.value, this.annexObject.uuid)
            .pipe(
              tap(() => this.processingRequest = false),
              tap((response: Uuid) => this.dialogRef.close(response.uuid)),
              mapTo('Pomyślnie zaktualizowano aneks'),
              catchError(() => {
                this.processingRequest = false;
                return of('Podczas przesyłania formularza wystąpił błąd');
              })
            )
            .subscribe((message: string) => {
              this.snack.open(message, '', {
                duration: 2000,
              });
            });
        }

      });
  }

  closeDialog(): void {
    if (!this.clone) {
      this.dialogRef.close();
    } else {
      this.commissionAnnexService.deleteClone(this.annexObject.uuid)
        .subscribe({
          next: () => {
            this.router.navigate(['/aneksy', this.filter]);

            this.dialogRef.close();
          },
          error: (error: HttpErrorResponse) => {
            this.snack.open('Przy usuwaniu wystąpił błąd', error.status.toString(), {duration: 2000});
          }
        });
    }
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.importerControl.setValue('');
    this.selectedInsuranceCompany = insuranceCompany;
  }
}
